import { createFileRoute } from "@tanstack/react-router";

import { McpClientPage } from "@/components/Mcp/McpClientPage";
import { getMcpClient } from "@/components/Mcp/mcpClients";
import { mcpClientHead } from "@/components/Mcp/mcpHead";

const client = getMcpClient("claude");

export const Route = createFileRoute("/mcp/claude")({
  component: () => <McpClientPage client={client} />,
  head: () => mcpClientHead(client),
});
